import { SelectField_default } from "./chunk-6TR6YPK3.js";
import { Select_Option_default } from "./chunk-EIUFV4NU.js";

// src/components/SelectField/index.tsx
var SelectFieldComponent = SelectField_default;
SelectFieldComponent.Option = Select_Option_default;
SelectFieldComponent.Option.displayName = "SelectField.Option";
export { SelectFieldComponent };